(ns journal-app-client.views.home
  (:require [clojure.string :as s]
            [goog.object :as g]
            [cljs.pprint :refer [pprint]]
            [journal-app-client.components.input :as input]
            [journal-app-client.config :as config]
            [journal-app-client.utils.css :as css]
            [journal-app-client.utils.interop :as interop]
            [journal-app-client.utils.react :as react]
            [re-frame.core :as rf]
            [cljs.core.async.interop :refer-macros [<p!]]
            [journal-app-client.components.container :refer [top-section]]
            [journal-app-client.components.icon :as icon]
            [journal-app-client.utils.hooks :as hooks]
            ["slate" :as slate]
            ["slate-react" :as slate-react]
            ["slate-history" :as slate-history]
            [reagent.core :as r]))
;; TODO: persist, count words, count entries, auto-save with popup notification about it
;; TODO: Move all interop related stuff to its own namespace
(def Slate (r/adapt-react-class (.-Slate slate-react)))
(def Editable (r/adapt-react-class (.-Editable slate-react)))

(defn get-marks [editor]
  (.marks (.-Editor slate) editor))
(defn get-mark [editor mark]
  (let [marks (get-marks editor)]
    (when marks (g/get marks mark))))
(defn remove-mark [editor & ks]
  (doseq [k ks]
    (.removeMark (.-Editor slate) editor k)))
(defn add-mark [editor map]
  (doseq [kv map]
    (.addMark (.-Editor slate) editor (first kv) (second kv))))

(defn is-block? [editor n]
  (.isBlock (.-Editor slate) editor n))

(defn match? [match format n]
  (when match (= (g/get n (or format "type")) match)))

(defn node-match? [editor match & [format]]
  (when match
    (not (nil? (first (.nodes (.-Editor slate) editor #js {:match (fn [n] (match? match format n))}))))))

(defn get-closest-block [editor & [match format]]
  (.above (.-Editor slate) editor #js {:match (fn [n]
                                                (if match
                                                  (and (match? match format n) (is-block? editor n))
                                                  (is-block? editor n)))}))

(defn toggle-block [editor props]
  (.setNodes (.-Transforms slate)
    editor
    props
    #js {:match (fn [n] (and (.isElement (.-Element slate) n) (is-block? editor n)))}))

(defn delete-backward [editor & [unit]]
  (let [unit (case unit
               :word "word"
               :text "text"
               "block")]
    (.deleteBackward (.-Editor slate) editor #js {:unit unit})))

(defn remove-nodes [editor & [options]]
  (.insertNodes (.-Transforms slate)
    editor
    (or options #js {})))

(defn insert-nodes [editor nodes & [options]]
  (.insertNodes (.-Transforms slate)
    editor
    nodes
    (or options #js {})))

(defn insert-fragment [editor node & [options]]
  (.insertFragment (.-Transforms slate)
    editor
    node
    (or options #js {})))

(defn insert-text [editor text & [options]]
  (.insertText (.-Transforms slate)
    editor
    text
    (or options #js {})))

(defn selection [editor]
  (.-selection editor))

(defn get-selection-text [editor]
  (when-let [selection (selection editor)] (.string (.-Editor slate) editor selection)))

(defn set-selection [editor & [options]]
  (.select (.-Transforms slate)
    editor
    (or options
      #js {:anchor #js {:path #js [0 0] :offset 4}
           :focus  #js {:path #js [1 0] :offset 2}})))

(defn move-cursor [editor & [{:keys [unit distance reverse?]}]]
  (let [unit (case unit
               :word "word"
               :text "text"
               "block")]
    (.move (.-Transforms slate)
      editor
      #js {:distance distance
           :unit     unit
           :reverse  reverse?})))

(defn editor-commands [editor command & [{:keys [use-state event mark marks] :as props}]]
  (case command
    :update-state
    (when use-state
      (let [[state set-state] use-state]
        (set-state
          (assoc state
            :selected-text (get-selection-text editor)
            :marks (js->clj (get-marks editor) {:keywordize-keys true})
            :block-formats {:font-family (cond (node-match? editor "Dawning of a new Day" "fontFamily") "Dawning of a new Day"
                                               (node-match? editor "roboto" "fontFamily") "roboto"
                                               :else nil)
                            :align (cond (node-match? editor "center" "align") "center"
                                         (node-match? editor "right" "align") "right"
                                         :else nil)}
            :active-block-type (cond (node-match? editor "p") "p"
                                     (node-match? editor "li") (editor-commands editor :get-closest-list-type)
                                     (node-match? editor "pre") "pre"
                                     (node-match? editor "blockquote") "blockquote"
                                     (node-match? editor "h1") "h1"
                                     (node-match? editor "h2") "h2"
                                     (node-match? editor "h3") "h3"
                                     (node-match? editor "h4") "h4"
                                     (node-match? editor "h5") "h5"
                                     (node-match? editor "h6") "h6"
                                     :else nil)))))

    :handle-tab-key
    (let [shift-key? (:shift-key? props)
          ctrl-key? (:ctrl-key? props)
          closest-block (get-closest-block editor)
          closest-type (.-type (first closest-block))
          path (second closest-block)
          depth (count path)]
      (case closest-type
        "li" (cond shift-key?
                   (let [new-path (drop-last path)
                         insert-at (clj->js (conj (vec (drop-last new-path)) (inc (last new-path))))]
                     (editor-commands nil :prevent-default {:event event})
                     (editor-commands editor :insert-nodes {:nodes   #js {:type (if (= depth 2) "p" "li")
                                                                          :children
                                                                          #js [#js {:text ""}]}
                                                            :options #js {:at insert-at}})
                     (move-cursor editor {:distance 1}))
                   :else
                   (let [insert-list-type (editor-commands editor :get-closest-list-type)]
                     (editor-commands nil :prevent-default {:event event})
                     (editor-commands editor :insert-list {:list insert-list-type})))
        nil))

    :handle-enter-key
    (let [shift-key? (:shift-key? props)
          ctrl-key? (:ctrl-key? props)
          closest-block (get-closest-block editor)
          closest-type (.-type (first closest-block))
          path (second closest-block)
          depth (count path)
          delete-fn (fn delete-fn []
                      (let [has-text? (not (= "" (.-text (first (.-children (first closest-block))))))]
                        (editor-commands nil :prevent-default {:event event})
                        (when has-text? (editor-commands editor :delete-backward {:unit :block}))
                        (editor-commands editor :delete-backward {:unit :block})))
          new-line-fn (fn new-line-fn []
                        (let [first-level (first path)
                              insert-at (clj->js [(inc first-level)])]
                          (editor-commands nil :prevent-default {:event event})
                          (editor-commands editor :insert-nodes {:nodes   #js [#js {:type "p" :children #js [#js {:text ""}]}]
                                                                 :options #js {:at insert-at}})
                          (move-cursor editor {:distance 1})))]
      (case closest-type
        ("i" "img" "video" "iframe")
        (if ctrl-key?
          (delete-fn)
          (new-line-fn))
        "li"
        (cond ctrl-key?
              (delete-fn)
              shift-key?
              (new-line-fn)
              :else
              nil)
        nil))

    :prevent-default
    (when event (.preventDefault event))

    :get-mark
    (get-mark editor (or mark (when (string? marks) marks)))

    :get-closest-list-type
    (let [closest-ul (get-closest-block editor "ul" "type")
          closest-ol (get-closest-block editor "ol" "type")
          depth-ul (count (second closest-ul))
          depth-ol (count (second closest-ol))]
      (if (> depth-ul depth-ol) "ul" "ol"))

    :node-match?
    (node-match? editor (:match props) (:format props))

    :toggle-mark
    (do (editor-commands nil :prevent-default {:event event})
        (if (editor-commands editor :get-mark props)
          (if (map? marks)
            (apply remove-mark editor (keys marks))
            (remove-mark editor marks))
          (add-mark editor (if (map? marks) marks {marks true}))))

    :toggle-underline-mark
    (do (editor-commands nil :prevent-default {:event event})
        (if (get-mark editor "underline")
          (remove-mark editor "underline")
          (do (add-mark editor {"underline" true})
              (remove-mark editor "strikethrough"))))

    :toggle-strikethrough-mark
    (do (editor-commands nil :prevent-default {:event event})
        (if (get-mark editor "strikethrough")
          (remove-mark editor "strikethrough")
          (do (add-mark editor {"strikethrough" true})
              (remove-mark editor "underline"))))

    :toggle-block-type
    (do (editor-commands nil :prevent-default {:event event})
        (let [is-active-block? (node-match? editor (:block-type props))
              type (if is-active-block? "p" (:block-type props))]
          (toggle-block editor #js {:type type})))

    :toggle-block-format
    (do (editor-commands nil :prevent-default {:event event})
        (let [is-active-font-family? (editor-commands editor :node-match? props)]
          (toggle-block editor (clj->js {(:format props) (when-not is-active-font-family? (:match props))}))))

    :insert-list
    (editor-commands editor :insert-nodes {:nodes #js [#js {:type (:list props)
                                                            :children
                                                            #js [#js {:type "li"
                                                                      :children
                                                                      #js [#js {:text ""}]}]}]
                                           :options (:options props)})

    :delete-backward
    (delete-backward editor (:unit props))

    :remove-nodes
    (insert-nodes editor (:options props))

    :insert-nodes
    (insert-nodes editor (:nodes props) (:options props))

    :insert-fragment
    (insert-fragment editor (:node props) (:options props))

    :insert-text
    (insert-text editor (:text props) (:options props))

    [:command-not-implemented command]))

(defn get-font-size [text-size]
  (case text-size
    "small" "0.75rem"
    "medium" "1.25rem"
    "large" "1.5rem"
    "huge" "2rem"
    nil))

(def colors
  [{:color "#e10000" :name "Red"}
   {:color "#e74c3c" :name "Fire"}
   {:color "#e67e22" :name "Orange"}
   {:color "#f1c40f" :name "Yellow"}
   {:color "#abebc6" :name "Mint"}
   {:color "#52be80" :name "Seafoam"}
   {:color "#117864" :name "Fern"}
   {:color "#00de14" :name "Green"}
   {:color "#00dee1" :name "Cyan"}
   {:color "#aed6f1" :name "Cloud"}
   {:color "#2471a3" :name "Cerulean"}
   {:color "#001ede" :name "Admiral"}
   {:color "#d2b4de" :name "Lavender"}
   {:color "#76448a" :name "Mauve"}
   {:color "#ca00de" :name "Purple"}
   {:color "#ff82af" :name "Pink"}
   {:color "#de0054" :name "Magenta"}])

(defn delete-button-wrap [{:keys [element editor]}]
  (let [selected (.useSelected slate-react)
        focused (.useFocused slate-react)]
    [:div
     {:contentEditable false
      :style {:position "relative"
              :display "inline-flex"}}
     [:button.is-clickable.glows.is-rounded
      {:style {:position "absolute"
               :top "1rem"
               :left "1rem"
               :display  (when-not (and focused selected) "none")
               :box-shadow "0 0 0.5em var(--scheme-main)"}
       :on-click #(editor-commands editor :delete-backward {:unit :block})}
      [:span.icon [:i.fas.fa-trash]]]
     element]))

(defn icon-el [class]
  [:span.icon
   {:contentEditable false
    :style {:display "inline-flex"}}
   [:i {:class class}]])

(defn image [url editor]
  [:f> delete-button-wrap
   {:editor editor
    :element [:img {:src url}]}])

(defn video [url editor]
  [:f> delete-button-wrap
   {:editor editor
    :element
    [:video
     {:autoPlay        true
      :muted           true
      :controls        true
      :style           {:border "1px solid var(--scheme-main)"}
      :src             url}]}])

(defn iframe [url editor]
  [:f> delete-button-wrap
   {:editor editor
    :element
    [:iframe
     {:width           "420"
      :height          "315"
      :frameborder "0"
      :allow "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      :allowfullscreen true
      :src             url}]}])

(defn react-element [& [props element-type editor]]
  (let [element-props ^js (.-element props)
        font-family (.-fontFamily element-props)
        align (.-align element-props)
        attributes (if (or font-family align)
                     (clj->js (assoc (js->clj (.-attributes props))
                                :style {:fontFamily font-family
                                        :display    (when align "flex")
                                        :justifyContent align
                                        :textAlign align}))
                     (.-attributes props))
        children (.-children props)]
    (case element-type
      "i" (r/create-element "div" attributes (r/as-element [icon-el (.-class element-props)]) children)
      "img" (r/create-element "div" attributes (r/as-element [image (.-url element-props) editor]) children)
      "video" (r/create-element "div" attributes (r/as-element [video (.-url element-props) editor]) children)
      "iframe" (r/create-element "div" attributes (r/as-element [iframe (.-url element-props) editor]) children)
      (r/create-element (or element-type "p")
        attributes
        children))))

(defn leaf-element [& [props]]
  (let [leaf-props ^js (.-leaf props)
        bold? (.-bold leaf-props)
        italic? (.-italic leaf-props)
        underline? (.-underline leaf-props)
        strikethrough? (.-strikethrough leaf-props)
        subscript? (.-subscript leaf-props)
        superscript? (.-superscript leaf-props)
        link? (.-link leaf-props)
        url (or (.-url leaf-props) (.-text leaf-props))
        text-size (g/get leaf-props "text-size")
        color (.-color leaf-props)
        background-color (g/get leaf-props "background-color")
        attributes (if (or italic? bold? underline? link? strikethrough? text-size color background-color)
                     (clj->js (assoc (js->clj (.-attributes props))
                                :href (when link? url)
                                :target (when link? "_blank")
                                :style {:color           color
                                        :backgroundColor background-color
                                        :fontSize        (get-font-size text-size)
                                        :fontWeight      (when bold? "bold")
                                        :fontStyle       (when italic? "italic")
                                        :textDecoration  (cond underline? "underline"
                                                               strikethrough? "line-through"
                                                               :else nil)}))
                     (.-attributes props))]
    (r/create-element
      (cond link? "a"
            strikethrough? "s"
            bold? "strong"
            italic? "em"
            underline? "u"
            subscript? "sub"
            superscript? "sup"
            :else "span")
      attributes
      (.-children props))))

(defn dropdown-content [{:keys [title selected-text icon-fn text-fn on-click use-active-dropdown]}]
  (let [[_ set-active-dropdown] use-active-dropdown
        [url set-url] (react/use-state)
        value (or url
                (if (or (s/starts-with? (or selected-text "") "https://www.")
                      (s/starts-with? (or selected-text "") "http://www."))
                  selected-text
                  (str "https://www." selected-text)))]
    (react/use-effect
      (fn []
        (if (or (s/starts-with? (or selected-text "") "https://www.")
              (s/starts-with? (or selected-text "") "http://www."))
          (set-url selected-text)
          (set-url nil))
        (fn []))
      #js [selected-text])
    [:<>
     [:span.help "Make sure the url starts with 'http://www.' or 'https://www.'"]
     [input/input
      {:placeholder "Url"
       :name title
       :value       value
       :on-change   #(set-url (-> % .-target .-value))}]
     [:button.button.is-fullwidth.is-small
      {:style    {:margin "0"}
       :disabled (or (nil? url) (= url ""))
       :on-click (fn []
                   (set-active-dropdown nil)
                   (on-click value))}
      (when (fn? text-fn) [:span (text-fn value)])
      (when (fn? icon-fn) [:span.icon (icon-fn value)])]]))

(defn link-url-dropdown [{:keys [editor mark-key marks use-active-dropdown] :as props}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        position (hooks/use-position-in-view ref mark-key)
        active? (= active-dropdown mark-key)
        mark-name (name mark-key)
        link-mark (get marks mark-key)
        url-mark (:url marks)
        title "Link"]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls (str mark-name "-menu")
        :title    title
        :style         {:color (when link-mark "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? mark-key)))}
       [:span.icon [:i.fas.fa-link]]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role "menu"
       :style {:min-width "16rem"}}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height      "15rem"
                :display "flex"
                :justify-content "center"
                :flex-wrap "wrap"
                :gap "0.5rem"
                :padding "1rem"}}
       [:span {:style {:text-align "center"}} title]
       [:f> dropdown-content
        (assoc props :title title
                     :on-click (fn [value]
                                 (set-active-dropdown nil)
                                 (editor-commands editor :toggle-mark {:mark  mark-name
                                                                       :marks {mark-name true
                                                                               "url"  value}}))
                     :text-fn (fn [value]
                                (let [is-already-marked? (= url-mark value)]
                                  (if is-already-marked? "Remove url" "Set link")))
                     :icon-fn (fn [value]
                                (let [is-already-marked? (= url-mark value)]
                                  (if is-already-marked? [:i.fas.fa-unlink] [:i.fas.fa-check]))))]]]]))

(defn void-type-url-dropdown [{:keys [editor icon type-key title active-block-type use-active-dropdown] :as props}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        position (hooks/use-position-in-view ref type-key)
        active? (= active-dropdown type-key)
        type-name (name type-key)
        active-block? (= type-name active-block-type)]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls (str title "-menu")
        :title         title
        :style         {:color (when active-block? "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? type-key)))}
       [:span.icon icon]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role  "menu"
       :style {:min-width "16rem"}}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height      "15rem"
                :display "flex"
                :flex-wrap "wrap"
                :justify-content "center"
                :gap "0.5rem"
                :padding "1rem"}}
       [:span {:style {:text-align "center"}} title]
       [:f> dropdown-content
        (assoc props :title title
                     :on-click (fn [value]
                                 (set-active-dropdown nil)
                                 (editor-commands editor :insert-nodes {:nodes #js [#js {:type type-name
                                                                                         :url  value
                                                                                         :children #js [#js {:text ""}]}]}))
                     :text-fn (fn [] "Insert")
                     :icon-fn (fn [] [:i.fas.fa-check]))]]]]))

(defn emoji-dropdown [{:keys [editor marks use-active-dropdown]}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        mark-key :emoji
        position (hooks/use-position-in-view ref mark-key)
        active? (= active-dropdown mark-key)
        mark-name (name mark-key)
        color-mark (get marks mark-key)]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls (str mark-name "-menu")
        :title         "Emoticons"
        :style         {:color (when color-mark "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? mark-key)))}
       [:span.icon [:i.fas.fa-face-kiss-wink-heart]]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role "menu"}
      (into
        [:div.dropdown-content.is-collapsible
         {:class (when-not active? "is-collapsed")
          :style {:max-height      "15rem"
                  :display         "flex"
                  :flex-wrap       "wrap"
                  :gap             "0.25rem"
                  :padding         "1rem"
                  :justify-content "center"}}]
        (map-indexed
          (fn [index emoji-class]
            [:a.dropdown-item
             {:key      (str emoji-class "-emoji-" index)
              :type     "button"
              :class    (when (= color-mark emoji-class) "is-active")
              :style    {:width   "1.5rem"
                         :height  "1.5rem"
                         :padding "0"
                         :border  "1px solid var(--scheme-invert)"}
              :on-click (fn []
                          (set-active-dropdown nil)
                          (editor-commands editor :insert-nodes {:nodes #js [#js {:type     "i"
                                                                                  :class    (str "twa " emoji-class)
                                                                                  :children #js [#js {:text ""}]}]}))}
             [:span.icon [:i.twa {:class emoji-class}]]])
          (:emoticons icon/emoji-list)))]]))

(defn color-dropdown [{:keys [mark-key editor marks use-active-dropdown]}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        position (hooks/use-position-in-view ref mark-key)
        active? (= active-dropdown mark-key)
        mark-name (name mark-key)
        color-mark (get marks mark-key)]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls (str mark-name "-menu")
        :title         (if (= mark-key :color) "Font color" "Background color")
        :style         {:color (when color-mark "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? mark-key)))}
       [:span.icon
        (if (= mark-key :color)
          [:i.fas.fa-palette]
          [:i.fas.fa-fill])]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role "menu"}
      (into
        (into
          [:div.dropdown-content.is-collapsible
           {:class (when-not active? "is-collapsed")
            :style {:max-height "15rem"
                    :display "flex"
                    :flex-wrap "wrap"
                    :gap "0.25rem"
                    :padding "1rem"
                    :justify-content "center"}}
           [:a.dropdown-item
            {:type     "button"
             :title "Transparent"
             :class (when-not color-mark "is-active")
             :style    {:width "1.5rem"
                        :height "1.5rem"
                        :padding "0"
                        :border "1px solid var(--scheme-invert)"
                        :background-color "transparent"}
             :on-click (fn []
                         (set-active-dropdown nil)
                         (editor-commands editor :toggle-mark {:mark mark-name :marks {mark-name nil}}))}]]
          (map-indexed
            (fn [index {:keys [color name]}]
              [:a.dropdown-item
               {:key      (str "color-" index)
                :type     "button"
                :title    name
                :class    (when (= color-mark color) "is-active")
                :style    {:background-color color
                           :width            "1.5rem"
                           :height "1.5rem"
                           :padding "0"
                           :border "1px solid var(--scheme-invert)"}
                :on-click (fn []
                            (set-active-dropdown nil)
                            (editor-commands editor :toggle-mark {:mark mark-name :marks {mark-name color}}))}])
            colors))
        [[:a.dropdown-item
          {:style {:padding "0"}}
          [:input.input
           {:type      "color"
            :value     (or color-mark (if (= (css/theme) :dark) "#000000" "#ffffff"))
            :on-change (fn [event]
                         (set-active-dropdown nil)
                         (editor-commands editor :toggle-mark {:mark mark-name :marks {mark-name (.-value (.-target event))}}))}]]])]]))

(defn alignment-dropdown [{:keys [editor state use-active-dropdown]}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        dropdown-id "alignment"
        position (hooks/use-position-in-view ref dropdown-id)
        active? (= active-dropdown dropdown-id)
        align (:align (:block-formats state))
        active-alignment? (contains? #{"center" "right"} align)]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls "alignment-menu"
        :title         "Alignment"
        :style         {:color (when active-alignment? "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? dropdown-id)))}
       [:span.icon
        (case align
          "center" [:i.fas.fa-align-center]
          "right" [:i.fas.fa-align-right]
          [:i.fas.fa-align-left])]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role  "menu"
       :style {:min-width "5rem"}}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height "10rem"}}
       [:a.dropdown-item
        {:type     "button"
         :title    "Align left"
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-format {:format "align"}))}
        [:span.icon {:style {:color (when-not active-alignment? "var(--info)")}}
         [:i.fas.fa-align-left]]]
       [:a.dropdown-item
        {:type     "button"
         :title    "Align center"
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-format {:format "align" :match "center"}))}
        [:span.icon {:style {:color (when (= align "middle") "var(--info)")}}
         [:i.fas.fa-align-center]]]
       [:a.dropdown-item
        {:type     "button"
         :title    "Align right"
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-format {:format "align" :match "right"}))}
        [:span.icon {:style {:color (when (= align "right") "var(--info)")}}
         [:i.fas.fa-align-right]]]]]]))

(defn font-family-dropdown [{:keys [editor state use-active-dropdown]}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        dropdown-id "font-family"
        position (hooks/use-position-in-view ref dropdown-id)
        active? (= active-dropdown "font-family")
        font-family (:font-family (:block-formats state))
        active-font-family? (contains? #{"Dawning of a new Day" "roboto"} font-family)]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls "font-family-menu"
        :title         "Strikethrough"
        :style         {:color (when active-font-family? "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? dropdown-id)))}
       [:span {:style {:margin "0 0 0 0.25rem"}}
        (or font-family "Serif")]
       [:span.icon [:i.fas.fa-font]]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role  "menu"
       :style {:min-width "14rem"}}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height "10rem"}}
       [:a.dropdown-item
        {:type     "button"
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-format {:format "fontFamily" :match "Dawning of a new Day"}))}
        [:span {:style {:color       (when (= font-family "Dawning of a new Day") "var(--info)")
                        :font-family "Dawning of a new Day"}}
         "Dawning of a new Day"]]
       [:a.dropdown-item
        {:type     "button"
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-format {:format "fontFamily" :match "roboto"}))}
        [:span {:style {:color       (when (= font-family "roboto") "var(--info)")
                        :font-family "roboto"}}
         "roboto"]]
       [:a.dropdown-item
        {:type     "button"
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-format {:format "fontFamily"}))}
        [:span {:style {:color (when (nil? font-family) "var(--info)")}}
         "Serif"]]]]]))

(defn header-dropdown [{:keys [editor active-block-type use-active-dropdown]}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        dropdown-id "header"
        position (hooks/use-position-in-view ref dropdown-id)
        active? (= active-dropdown "header")
        active-block-header? (contains? #{"h1" "h2" "h3" "h4" "h5" "h6"} active-block-type)]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls "header-menu"
        :title         "Strikethrough"
        :style         {:color (when active-block-header? "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? dropdown-id)))}
       [:span {:style {:margin "0 0 0 0.25rem"}}
        (case active-block-type
          "h1" "Header 1"
          "h2" "Header 2"
          "h3" "Header 3"
          "h4" "Header 4"
          "h5" "Header 5"
          "h6" "Header 6"
          "Normal")]
       [:span.icon [:i.fas.fa-heading]]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role  "menu"
       :style {:min-width "16rem"}}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height "22rem"}}
       [:a.dropdown-item
        {:type     "button"
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-type {:block-type "h1"}))}
        [:span.title.is-1 {:style {:color (when (= active-block-type "h1") "var(--info)")}}
         "Header 1"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color (when (= active-block-type "h2") "var(--info)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-type {:block-type "h2"}))}
        [:span.title.is-2 {:style {:color (when (= active-block-type "h2") "var(--info)")}}
         "Header 2"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color (when (= active-block-type "h3") "var(--info)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-type {:block-type "h3"}))}
        [:span.title.is-3 {:style {:color (when (= active-block-type "h3") "var(--info)")}}
         "Header 3"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color (when (= active-block-type "h4") "var(--info)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-type {:block-type "h4"}))}
        [:span.title.is-4 {:style {:color (when (= active-block-type "h4") "var(--info)")}}
         "Header 4"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color (when (= active-block-type "h5") "var(--info)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-type {:block-type "h5"}))}
        [:span.title.is-5 {:style {:color (when (= active-block-type "h5") "var(--info)")}}
         "Header 5"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color (when (= active-block-type "h6") "var(--info)")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-block-type {:block-type "h6"}))}
        [:span.title.is-6 {:style {:color (when (= active-block-type "h6") "var(--info)")}}
         "Header 6"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color (when-not active-block-header? "var(--info)")}
         :on-click #(editor-commands editor :toggle-block-type)}
        [:span "Normal"]]]]]))

(defn text-size-dropdown [{:keys [editor marks use-active-dropdown]}]
  (let [[active-dropdown set-active-dropdown] use-active-dropdown
        ref (react/use-ref)
        dropdown-id "text-size"
        position (hooks/use-position-in-view ref dropdown-id)
        active? (= active-dropdown "text-size")
        text-size-mark (:text-size marks)]
    [:div.dropdown.is-active.is-center
     {:style {"--_offset-translate" (str position "px")}}
     [:div.dropdown-trigger
      [:button.is-clickable.glows
       {:aria-haspopup true
        :aria-controls "text-size-menu"
        :title         "Text size"
        :style         {:color (when text-size-mark "var(--info)")}
        :on-click      (fn [event]
                         (set-active-dropdown (when-not active? dropdown-id)))}
       [:span {:style {:margin "0 0 0 0.25rem"}}
        (case text-size-mark
          "small" "Small"
          "medium" "Medium"
          "large" "Large"
          "huge" "Huge"
          "Normal")]
       [:span.icon [:i.fas.fa-text-height]]
       [icon/angle-down
        {:aria-hidden active?
         :active?     active?}]]]
     [:div.dropdown-menu
      {:ref ref
       :role "menu"}
      [:div.dropdown-content.is-collapsible
       {:class (when-not active? "is-collapsed")
        :style {:max-height "15rem"}}
       [:a.dropdown-item
        {:type     "button"
         :style    {:color     (when (= text-size-mark "small") "var(--info)")
                    :font-size (get-font-size "small")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-mark {:marks {"text-size" "small"}}))}
        [:span "Small"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color     (when-not text-size-mark "var(--info)")
                    :font-size "1rem"}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-mark {:marks {"text-size" nil}}))}
        [:span "Normal"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color     (when (= text-size-mark "medium") "var(--info)")
                    :font-size (get-font-size "medium")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-mark {:marks {"text-size" "medium"}}))}
        [:span "Medium"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color     (when (= text-size-mark "large") "var(--info)")
                    :font-size (get-font-size "large")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-mark {:marks {"text-size" "large"}}))}
        [:span "Large"]]
       [:a.dropdown-item
        {:type     "button"
         :style    {:color     (when (= text-size-mark "huge") "var(--info)")
                    :font-size (get-font-size "huge")}
         :on-click (fn []
                     (set-active-dropdown nil)
                     (editor-commands editor :toggle-mark {:marks {"text-size" "huge"}}))}
        [:span "Huge"]]]]]))

(defn editor-toolbar [editor state]
  (let [[active-dropdown set-active-dropdown] (react/use-state)
        marks (:marks state)
        active-block-type (:active-block-type state)
        selected-text (:selected-text state)]
    [:div
     {:style {:padding         "1rem"
              :border-top          "1px solid var(--primary-brand-color)"
              :border-left          "1px solid var(--primary-brand-color)"
              :border-right          "1px solid var(--primary-brand-color)"
              :border-radius   "var(--border-radius-medium) var(--border-radius-medium) 0 0"
              :display         "flex"
              :justify-content "space-between"
              :gap             "0.5rem"
              :flex-wrap       "wrap"}
      :on-pointer-down (when (config/touch-enabled-device?)
                         (fn [event]
                           (.preventDefault event)
                           (when-let [el (interop/get-element-by-id "my-editor")] (.focus el))))}
     [:div
      [:button.is-clickable.glows
       {:title    "Bold"
        :style    {:color (when (:bold marks) "var(--info)")}
        :on-click #(editor-commands editor :toggle-mark {:marks "bold"})}
       [:span.icon [:i.fas.fa-bold]]]
      [:button.is-clickable.glows
       {:title    "Italic"
        :style    {:color (when (:italic marks) "var(--info)")}
        :on-click #(editor-commands editor :toggle-mark {:marks "italic"})}
       [:span.icon [:i.fas.fa-italic]]]
      [:button.is-clickable.glows
       {:title    "Underline"
        :style    {:color (when (:underline marks) "var(--info)")}
        :on-click #(editor-commands editor :toggle-underline-mark)}
       [:span.icon [:i.fas.fa-underline]]]
      [:button.is-clickable.glows
       {:title    "Strikethrough"
        :style    {:color (when (:strikethrough marks) "var(--info)")}
        :on-click #(editor-commands editor :toggle-strikethrough-mark)}
       [:span.icon [:i.fas.fa-strikethrough]]]]
     #_[:f> emoji-dropdown {:editor editor :marks marks :use-active-dropdown [active-dropdown set-active-dropdown]}]
     [:f> font-family-dropdown {:editor editor :state state :use-active-dropdown [active-dropdown set-active-dropdown]}]
     [:f> text-size-dropdown {:editor editor :marks marks :use-active-dropdown [active-dropdown set-active-dropdown]}]
     [:f> header-dropdown {:editor editor :active-block-type active-block-type :use-active-dropdown [active-dropdown set-active-dropdown]}]
     [:div
      [:f> link-url-dropdown
       {:editor editor :mark-key :link :marks marks :selected-text selected-text
        :use-active-dropdown [active-dropdown set-active-dropdown]}]
      [:f> void-type-url-dropdown
       {:editor editor :type-key :img :title "Image" :active-block-type active-block-type
        :selected-text selected-text
        :use-active-dropdown [active-dropdown set-active-dropdown]
        :icon [:i.fas.fa-image]}]
      [:f> void-type-url-dropdown
       {:editor editor :type-key :iframe :title "Iframe" :active-block-type active-block-type
        :selected-text selected-text
        :use-active-dropdown [active-dropdown set-active-dropdown]
        :icon [:i.fas.fa-globe]}]
      [:f> void-type-url-dropdown
       {:editor editor :type-key :video :title "Video" :active-block-type active-block-type
        :selected-text selected-text
        :use-active-dropdown [active-dropdown set-active-dropdown]
        :icon [:i.fas.fa-film]}]]
     [:div
      [:f> color-dropdown {:mark-key :color
                           :editor   editor :marks marks :use-active-dropdown [active-dropdown set-active-dropdown]}]
      [:f> color-dropdown {:mark-key :background-color
                           :editor   editor :marks marks :use-active-dropdown [active-dropdown set-active-dropdown]}]]
     [:f> alignment-dropdown {:editor editor :state state :use-active-dropdown [active-dropdown set-active-dropdown]}]
     [:div
      [:button.is-clickable.glows
       {:title    "Unordered list"
        :style    {:color (when (= "ul" active-block-type) "var(--info)")}
        :on-click #(editor-commands editor :insert-list {:list "ul"})}
       [:span.icon [:i.fas.fa-list-ul]]]
      [:button.is-clickable.glows
       {:title    "Ordered list"
        :style    {:color (when (= "ol" active-block-type) "var(--info)")}
        :on-click #(editor-commands editor :insert-list {:list "ol"})}
       [:span.icon [:i.fas.fa-list-ol]]]]
     [:div
      [:button.is-clickable.glows
       {:title    "Subscript"
        :style    {:color (when (:subscript marks) "var(--info)")}
        :on-click #(editor-commands editor :toggle-mark {:marks "subscript"})}
       [:span.icon [:i.fas.fa-subscript]]]
      [:button.is-clickable.glows
       {:title    "Superscript"
        :style    {:color (when (:superscript marks) "var(--info)")}
        :on-click #(editor-commands editor :toggle-mark {:marks "superscript"})}
       [:span.icon [:i.fas.fa-superscript]]]]
     [:div
      [:button.is-clickable.glows
       {:title    "Block quote"
        :style    {:color (when (= "blockquote" active-block-type) "var(--info)")}
        :on-click #(editor-commands editor :toggle-block-type {:block-type "blockquote"})}
       [:span.icon [:i.fas.fa-quote-right]]]
      [:button.is-clickable.glows
       {:title    "Code Block"
        :style    {:color (when (= "pre" active-block-type) "var(--info)")}
        :on-click #(editor-commands editor :toggle-block-type {:block-type "pre"})}
       [:span.icon [:i.fas.fa-code]]]]]))

(defn slate-editor []
  (let [initial-value [{:type     "h1"
                        :children [{:text "Welcome to Yume"}],}
                       {:type     "p"
                        :children [{:text "Let's start writing! 😊"}],}]
        ^js editor (react/use-memo (fn [] (.withHistory slate-history (.withReact slate-react (.createEditor slate))))
                       #js [true])
        [state set-state] (react/use-state {})
        render-element (react/use-callback
                           (fn render-element [props]
                             (react-element props (.-type (.-element props)) editor))
                           #js [true])
        render-leaf (react/use-callback
                      (fn render-leaf [props]
                        (leaf-element props))
                      #js [true])]
    (react/use-effect
      (fn []
        #_(set! (.-isInLine editor)
          (fn [element]
            (or (contains? #{"i"} (.-type element)) (.isInLine editor element))))
        #_(set! (.-isElementReadOnly editor)
          (fn [element]
            (or (contains? #{} (.-type element)) (.isElementReadOnly editor element))))
        #_(set! (.-isSelectable editor)
          (fn [element]
            (or (contains? #{} (.-type element)) (.isSelectable editor element))))
        (fn []
          ))
      #js [true])
    [Slate
     {:editor        editor
      :initial-value initial-value
      :on-change     (fn [value]
                       (pprint "change")
                       (editor-commands editor :update-state {:use-state [state set-state]})
                       #_(when-let [actual-change (.some (.-operations editor) (fn [op] (not (= "set_selection" (.-type op)))))]
                         (interop/debounce
                           :slate-editor-on-change
                           (fn []
                             (pprint actual-change)
                             (if actual-change
                               (pprint (js->clj value))
                               (pprint "Selection")))
                           2000)))}
     [:f> editor-toolbar editor state]
     [Editable
      {:class          "content"
       :id "my-editor"
       :style          {:padding       "1rem"
                        :border        "1px solid var(--primary-brand-color)"
                        :border-radius "0 0 var(--border-radius-medium) var(--border-radius-medium)"
                        :outline "none"
                        :min-height "30vh"}
       :on-focus #(pprint "hello")
       :render-element render-element
       :render-leaf    render-leaf
       :on-key-down    (fn [event]
                         (let [event-key event.key
                               ctrl-key? event.ctrlKey
                               shift-key? event.shiftKey]
                           (when (= event-key "Enter")
                             (editor-commands editor :handle-enter-key {:ctrl-key?  ctrl-key?
                                                                        :shift-key? shift-key?
                                                                        :event      event}))
                           (when (= event-key "Tab")
                             (editor-commands editor :handle-tab-key {:ctrl-key?  ctrl-key?
                                                                      :shift-key? shift-key?
                                                                      :event event}))
                           (when ctrl-key?
                             (case event-key
                               "`"
                               (editor-commands editor :toggle-block-type {:event event :block-type "pre"})
                               "b"
                               (editor-commands editor :toggle-mark {:marks "bold" :event event})
                               "i"
                               (editor-commands editor :toggle-mark {:marks "italic" :event event})
                               "u"
                               (editor-commands editor :toggle-underline-mark {:event event})
                               "s"
                               (editor-commands editor :toggle-strikethrough-mark {:event event})
                               "l"
                               (editor-commands editor :toggle-mark {:event event :mark "link" :marks {"link" true "url" nil}})
                               nil))))}]]))

(defn view [& [props]]
  (let [notification-permission? @(rf/subscribe [:notification-permission?])
        notification-persistent? @(rf/subscribe [:notification-persistent?])
        app-installable? @(rf/subscribe [:app-installable?])
        display-mode @(rf/subscribe [:display-mode])
        connection-information @(rf/subscribe [:connection-information])
        user-selected-theme @(rf/subscribe [:theme :user-selected])
        system-theme @(rf/subscribe [:theme :system])
        theme @(rf/subscribe [:theme])]
    [top-section
     {:style {:overflow "unset"}}
     [:f> slate-editor]]))
